import type { ComponentType } from "react";
import { EmptyState } from "@/components/organisms/EmptyState";

interface ComingSoonPageProps {
  illustration: ComponentType<{ className?: string }>;
  title: string;
  description: string;
  stageLabel: string;
  actionLabel?: string;
  onAction?: () => void;
}

/**
 * Página de espaço reservado para módulos que serão implementados nas
 * próximas etapas (Jogos, Ranking...). Mantém a rota, o menu inferior e o
 * layout já funcionais desde a Etapa 1, com Empty State ilustrado (nunca
 * uma tela em branco), sem simular dados. Aceita uma ação opcional pra
 * nunca virar um beco sem saída (ex.: "Grupos" ainda não tem lista própria,
 * mas oferece atalho pra criar liga).
 */
export function ComingSoonPage({ illustration, title, description, stageLabel, actionLabel, onAction }: ComingSoonPageProps) {
  return (
    <div className="flex min-h-[65vh] flex-col justify-center">
      <EmptyState illustration={illustration} title={title} description={description} actionLabel={actionLabel} onAction={onAction} />
      <p className="mt-4 text-center text-xs font-medium uppercase tracking-wide text-muted-foreground/70">
        {stageLabel}
      </p>
    </div>
  );
}
